import Toast from './Toast'
let Tst = {}
Tst.install = function (Vue, options) {
  if (document.getElementsByClassName('toast').length) {
    return
  }
  const VueToast = Vue.extend(Toast)
  let $vm = new VueToast({
    el: document.createElement('div')
  })

  let tst = $vm.$mount().$el
  document.body.appendChild(tst)

  Vue.prototype.$showToast = {
    show (options) {
      if (typeof options === 'string') {
        $vm.text = options
      } else if (typeof options === 'object') {
        Object.assign($vm, options)
      }
      $vm.isShow = true
      if ($vm.type === 'loading') {
        let timer = setTimeout(() => {
          $vm.isShow = false
          timer && clearTimeout(timer)
        }, 30000)
        document.getElementById('app').style.zIndex = -1
      } else {
        let timer = setTimeout(() => {
          $vm.isShow = false
          timer && clearTimeout(timer)
        }, $vm.time || 1000)
        document.getElementById('app').style.zIndex = 0
      }
    },
    hide () {
      $vm.isShow = false
      document.getElementById('app').style.zIndex = 0
    }
  }
}
export default Tst



// WEBPACK FOOTER //
// ./src/plugins/ShowToast/ShowToast.js